import React, { useEffect, useState } from 'react';

import LoadStatus from 'config/load_status';

import useAuthentication from 'domain/authentication/useAuthentication';
import myRecipesListener from 'domain/recipe/usecases/my_recipes_listener';

export const RecipesContext = React.createContext();

const RecipesProvider = ({ children }) => {
  const { isAuthenticated, user } = useAuthentication();
  const [myRecipes, setMyRecipes] = useState([]);
  const [loadMyRecipesStatus, setLoadMyRecipesStatus] = useState(null);

  const onRecipesReceived = (recipes) => {
    setMyRecipes(recipes);
    setLoadMyRecipesStatus(LoadStatus.DONE);
  };

  useEffect(() => {
    if (!isAuthenticated) return;
    if (loadMyRecipesStatus !== LoadStatus.LOADING) return;

    myRecipesListener(user, onRecipesReceived);
  }, [loadMyRecipesStatus, user, isAuthenticated]);

  useEffect(() => {
    if (!isAuthenticated) {
      setLoadMyRecipesStatus(null);
      setMyRecipes([]);
    }
  }, [isAuthenticated]);

  const loadMyRecipes = () => {
    if (
      loadMyRecipesStatus === LoadStatus.LOADING ||
      loadMyRecipesStatus === LoadStatus.DONE ||
      !isAuthenticated
    )
      return;

    setLoadMyRecipesStatus(LoadStatus.LOADING);
  };

  return (
    <RecipesContext.Provider
      value={{
        myRecipes,
        loadMyRecipesStatus,
        loadMyRecipes,
      }}
    >
      {children}
    </RecipesContext.Provider>
  );
};

export default RecipesProvider;
